/**
 * Must match EngineType.java in the backend!
 */
export enum EngineType {
  BATTERY = 'BATTERY',
  CNG = 'CNG',
  BI_ENERGY = 'BI_ENERGY',
  BI_ENERGY_BATTERY_ELECTRIC = 'BI_ENERGY_BATTERY_ELECTRIC',
  BI_ENERGY_DIESEL_ELECTRIC = 'BI_ENERGY_DIESEL_ELECTRIC',
  BI_ENERGY_GASOLINE_ELECTRIC = 'BI_ENERGY_GASOLINE_ELECTRIC',
  DIESEL = 'DIESEL',
  DUAL_FUEL_GASOLINE_LPG = 'DUAL_FUEL_GASOLINE_LPG',
  ELECTRIC = 'ELECTRIC',
  GASOLINE = 'GASOLINE',
  HYBRID = 'HYBRID',
  LPG = 'LPG',
  MANUAL = 'MANUAL',
  PNEUMATIC = 'PNEUMATIC',
  UNKNOWN = 'UNKNOWN'
}
